"use client";

import useShouldFire from "./hooks/useShouldFire";

const PixelsOtherScripts = ({ GTM_ID }: { GTM_ID: number | string }) => {
  const shouldFire = useShouldFire();
  const OSOSS_GTM_ID = process.env.NEXT_PUBLIC_OSOSS_GTM_ID ?? "";
  if (!shouldFire) return;
  return (
    <>
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${OSOSS_GTM_ID}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>
      {/* google tag manger */}
      {GTM_ID && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          />
        </noscript>
      )}
    </>
  );
};

export default PixelsOtherScripts;
